import React, { createContext, useState } from 'react'

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  /* const [isSocket, setSocket] = useState(new WebSocket(`${process.env.REACT_APP_WEBSOCKET}`))
  const value = {
    isSocket
  } */
  const value = {}
  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  )
}
